// Courtesy of https://stackoverflow.com/questions/51819224/how-to-find-nearest-location-using-latitude-and-longitude-from-a-json-data
export function calculateDistance(lat1, lon1, lat2, lon2, unit) {
  let radlat1 = Math.PI * lat1/180;
  let radlat2 = Math.PI * lat2/180;
  let theta = lon1-lon2;
  let radtheta = Math.PI * theta/180;
  let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = dist * 180/Math.PI;
  dist = dist * 60 * 1.1515;
  // Default unit is "M" for miles
  if (unit=="K") { dist = dist * 1.609344 }
  if (unit=="N") { dist = dist * 0.8684 }
  return dist;
}

// Get all parameters in URL
export function getUrlParams(name) {
	var results = new RegExp("[\?&]" + name + "=([^&#]*)")
		.exec(window.location.search);
	return results !== null ? results[1] || 0 : false;
}

// Sanitize phone link
export function makePhoneLink(str) {
  str = str.replace(/[^0-9]/g, "");
  return str;
}